<template>
    <div>
        <!-- <h1>排行榜页面</h1> -->
        <el-row type="flex" justify="center">
            <el-col :span="12">
                <div>各单位考勤排行榜</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="dwkqYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="dwkqMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="dwkqSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="dwkqData" style="width: 100%" v-loading="loadingDwkq">
                        <!-- <el-table-column type="index"></el-table-column> -->
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[(scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '1' ? 'index_one' : (scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '2' ? 'index_two' : (scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[(scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '1' ? 'index_one' : (scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '2' ? 'index_two' : (scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq == '3' ? 'index_three' : 'index_four']">
                              {{ (scope.$index + 1)+(currentNoDwkq-1)*pageSizeDwkq }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="BMMC" label="单位" ></el-table-column>
                        <el-table-column prop="JBCS" label="加班排行" sortable></el-table-column>
                        <el-table-column prop="KGCS" label="旷工排行" sortable></el-table-column>
                        <el-table-column prop="BJCS" label="病假排行" sortable></el-table-column>
                        <el-table-column prop="SJCS" label="事假排行" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeDwkq" @current-change="handleCurrentChangeDwkq" :current-page="currentNoDwkq"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeDwkq" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalDwkq">
                    </el-pagination>
                </div>
            </el-col>
            <el-col :span="12">
                <div>个人考勤排行榜</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="grkqYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="grkqMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="grkqSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="grkqData" style="width: 100%" v-loading="loadingGrkq">
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[(scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '1' ? 'index_one' : (scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '2' ? 'index_two' : (scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[(scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '1' ? 'index_one' : (scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '2' ? 'index_two' : (scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq == '3' ? 'index_three' : 'index_four']">
                                {{ (scope.$index + 1)+(currentNoGrkq-1)*pageSizeGrkq }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="XM" label="姓名"></el-table-column>
                        <el-table-column prop="JBCS" label="加班排行" sortable></el-table-column>
                        <el-table-column prop="KGCS" label="旷工排行" sortable></el-table-column>
                        <el-table-column prop="BJCS" label="病假排行" sortable></el-table-column>
                        <el-table-column prop="SJCS" label="事假排行" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeGrkq" @current-change="handleCurrentChangeGrkq" :current-page="currentNoGrkq"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeGrkq" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalGrkq">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center" style="margin-top:32px">
            <el-col :span="12">
                <div>合同金额排行榜</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="htjeYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="htjeMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="htjeSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="htjeData" style="width: 100%" v-loading="loadingHtje">
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[(scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '1' ? 'index_one' : (scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '2' ? 'index_two' : (scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[(scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '1' ? 'index_one' : (scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '2' ? 'index_two' : (scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje == '3' ? 'index_three' : 'index_four']">
                              {{ (scope.$index + 1)+(currentNoHtje-1)*pageSizeHtje }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="CUSTOMER_NAME" label="单位名称"></el-table-column>
                        <el-table-column prop="AMOUNT" label="合同金额(元)" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeHtje" @current-change="handleCurrentChangeHtje" :current-page="currentNoHtje"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeHtje" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalHtje">
                    </el-pagination>
                </div>
            </el-col>
            <el-col :span="12">
                <div>保安用工排行榜</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="baygYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="baygMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="baygSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="baygData" style="width: 100%" v-loading="loadingBayg">
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[(scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '1' ? 'index_one' : (scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '2' ? 'index_two' : (scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[(scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '1' ? 'index_one' : (scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '2' ? 'index_two' : (scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg == '3' ? 'index_three' : 'index_four']">
                                {{ (scope.$index + 1)+(currentNoBayg-1)*pageSizeBayg }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="CUSTOMER_NAME" label="单位名称"></el-table-column>
                        <el-table-column prop="NUM" label="用工人数" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeBayg" @current-change="handleCurrentChangeBayg" :current-page="currentNoBayg"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeBayg" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalBayg">
                    </el-pagination>
                </div>
            </el-col>
        </el-row>

        <el-row type="flex" justify="center" style="margin-top:32px">
            <el-col :span="12">
                <div>应收未收款项情况</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="yswskYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="yswskMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="yswskSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="yswskData" style="width: 100%" v-loading="loadingYswsk">
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[(scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '1' ? 'index_one' : (scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '2' ? 'index_two' : (scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[(scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '1' ? 'index_one' : (scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '2' ? 'index_two' : (scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk == '3' ? 'index_three' : 'index_four']">
                                {{ (scope.$index + 1)+(currentNoYswsk-1)*pageSizeYswsk }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="CUSTOMER_NAME" label="单位名称"></el-table-column>
                        <el-table-column prop="YINSJE" label="应收金额(元)" sortable></el-table-column>
                        <el-table-column prop="YISJE" label="已收金额(元)" sortable></el-table-column>
                        <el-table-column prop="WSJE" label="未收金额(元)" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeYswsk" @current-change="handleCurrentChangeYswsk" :current-page="currentNoYswsk"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeYswsk" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalYswsk">
                    </el-pagination>
                </div>
            </el-col>
            <el-col :span="12">
                <!-- <div>各大队利润排行</div>
                <div class="data" style="text-align: left;">
                    <el-date-picker v-model="lrphYear" type="year" format="yyyy年" value-format="yyyy" placeholder="选择年" class="margin_right"></el-date-picker>
                    <el-date-picker v-model="lrphMonth" type="month" format="M月" value-format="MM" placeholder="选择月" popper-class="month_class" class="margin_right"></el-date-picker>
                    <el-button type="primary" @click="lrphSearch()">查询</el-button>
                </div>
                <div class="data">
                    <el-table :data="baygData" style="width: 100%" v-loading="loadinglrph">
                        <el-table-column  type="index" width="70px">
                        <template scope="scope">
                          <div v-bind:class="[scope.$index + 1 == '1' ? 'index_one' : scope.$index + 1 == '2' ? 'index_two' : scope.$index + 1 == '3' ? 'index_three' : 'index_four']">
                            <span v-bind:class="[scope.$index + 1 == '1' ? 'index_one' : scope.$index + 1 == '2' ? 'index_two' : scope.$index + 1 == '3' ? 'index_three' : 'index_four']">
                              {{ scope.$index + 1 }}
                            </span>
                          </div>
                        </template>
                      </el-table-column>
                        <el-table-column prop="CUSTOMER_NAME" label="单位名称"></el-table-column>
                        <el-table-column prop="NUM" label="金额" sortable></el-table-column>
                    </el-table>
                    <el-pagination @size-change="handleSizeChangeBayg" @current-change="handleCurrentChangeBayg" :current-page="currentNoBayg"
                    :page-sizes="[10, 20, 50, 100]" :page-size="pageSizeBayg" layout="total, sizes, prev, pager, next, jumper" :total="pageTotalBayg">
                    </el-pagination>
                </div> -->
                <!-- <div>个人考勤排行榜</div> -->
                <!-- <div class="data">
                    <el-table :data="tableData" style="width: 100%">
                        <el-table-column prop="XM" label="姓名"></el-table-column>
                        <el-table-column prop="JBCS" label="加班排行"></el-table-column>
                        <el-table-column prop="KGCS" label="旷工排行"></el-table-column>
                        <el-table-column prop="BJCS" label="病假排行"></el-table-column>
                        <el-table-column prop="SJCS" label="事假排行"></el-table-column>
                    </el-table>
                </div> -->

            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dwkqYear: '',
                dwkqMonth: '',
                dwkqSearDate: '',
                grkqYear: '',
                grkqMonth: '',
                grkqSearDate: '',
                htjeYear: '',
                htjeMonth: '',
                htjeSearDate: '',
                baygYear: '',
                baygMonth: '',
                lrphMonth:'',
                baygSearDate: '',
                lrphSearDate: '',
                yswskYear: '',
                yswskMonth: '',
                yswskSearDate: '',
                dwkqData: [],
                grkqData: [],
                htjeData: [],
                baygData: [],
                yswskData: [],
                loadingDwkq: false,
                loadingGrkq: false,
                loadingHtje: false,
                loadingBayg: false,
                loadinglrph:false,
                loadingYswsk: false,
                currentNoDwkq: 1,
                pageSizeDwkq: 10,
                pageTotalDwkq: 0,
                currentNoGrkq: 1,
                pageSizeGrkq: 10,
                pageTotalGrkq: 0,
                currentNoHtje: 1,
                pageSizeHtje: 10,
                pageTotalHtje: 0,
                currentNoBayg: 1,
                currentNoLrph: 1,
                pageSizeBayg: 10,
                pageSizeLrph: 10,
                pageTotalBayg: 0,
                pageTotalLrph: 0,
                currentNoYswsk: 1,
                pageSizeYswsk: 10,
                pageTotalYswsk: 0,
            }
        },
        mounted() {
            this.getCurrentTime();
        },
        methods: {
            getCurrentTime() {
                //获取当前时间并打印
                let nf = new Date().getFullYear();
                this.dwkqYear = nf + '';
                this.dwkqSearDate = this.dwkqYear;
                this.grkqYear = nf + '';
                this.grkqSearDate = this.grkqYear;
                this.htjeYear = nf + '';
                this.htjeSearDate = this.htjeYear;
                this.baygYear = nf + '';
                this.baygSearDate = this.baygYear;
                this.lrphSearDate = this.baygYear;
                this.yswskYear = nf + '';
                this.yswskSearDate = this.yswskYear;
                this.getDwkqData(nf)
                this.getGrkqData(nf)
                this.getHtjeData(nf)
                this.getBaygData(nf)
                this.getYswskData(nf)
            },
            dwkqSearch(){
                if (!this.dwkqYear) {
                    this.$message.error("请选择年份！")
                } else {
                    if (this.dwkqMonth) {
                        this.dwkqSearDate = this.dwkqYear + '-' + this.dwkqMonth
                    } else {
                        this.dwkqSearDate = this.dwkqYear
                    }
                    this.getDwkqData(this.dwkqSearDate);
                }
            },
            getDwkqData(date){
                this.loadingDwkq = true;
                this.$request({
					url: '/bjba/phb/gdwkqphb',
					method: 'get',
                    params: {
                        pageNum: this.currentNoDwkq,
                        pageSize: this.pageSizeDwkq,
                        date: date
                    }
				})
				.then(response => {
                    this.loadingDwkq = false;
					console.log("单位考勤：",response)
                    this.dwkqData = response.data.data
                    this.pageTotalDwkq = response.data.total
				})
				.catch(error => {
					this.loadingDwkq = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            handleSizeChangeDwkq(val) {
                this.pageSizeDwkq = val;
                this.getDwkqData(this.dwkqSearDate);
            },
            handleCurrentChangeDwkq(val) {
                this.currentNoDwkq = val;
                this.getDwkqData(this.dwkqSearDate);
            },
            grkqSearch(){
                if (!this.grkqYear) {
                    this.$message.error("请选择年份！")
                } else {
                    if (this.grkqMonth) {
                        this.grkqSearDate = this.grkqYear + '-' + this.grkqMonth
                    } else {
                        this.grkqSearDate = this.grkqYear
                    }
                    this.getGrkqData(this.grkqSearDate);
                }
            },
            getGrkqData(date){
                this.loadingGrkq = true;
                this.$request({
					url: '/bjba/phb/grkqphb',
					method: 'get',
                    params: {
                        pageNum: this.currentNoGrkq,
                        pageSize: this.pageSizeGrkq,
                        date: date
                    }
				})
				.then(response => {
                    this.loadingGrkq = false;
					console.log("个人考勤：",response)
                    this.grkqData = response.data.data
                    this.pageTotalGrkq = response.data.total
				})
				.catch(error => {
					this.loadingGrkq = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            handleSizeChangeGrkq(val) {
                this.pageSizeGrkq = val;
                this.getGrkqData(this.grkqSearDate);
            },
            handleCurrentChangeGrkq(val) {
                this.currentNoGrkq = val;
                this.getGrkqData(this.grkqSearDate);
            },
            htjeSearch(){
                if (!this.htjeYear) {
                    this.$message.error("请选择年份！")
                } else {
                    if (this.htjeMonth) {
                        this.htjeSearDate = this.htjeYear + '-' + this.htjeMonth
                    } else {
                        this.htjeSearDate = this.htjeYear
                    }
                    this.getHtjeData(this.htjeSearDate);
                }
            },
            getHtjeData(date){
                this.loadingHtje = true;
                this.$request({
					url: '/bjba/phb/htjephb',
					method: 'get',
                    params: {
                        pageNum: this.currentNoHtje,
                        pageSize: this.pageSizeHtje,
                        date: date
                    }
				})
				.then(response => {
                    this.loadingHtje = false;
					console.log("合同金额：",response)
                    this.htjeData = response.data.data
                    this.pageTotalHtje = response.data.total
				})
				.catch(error => {
					this.loadingHtje = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            handleSizeChangeHtje(val) {
                this.pageSizeHtje = val;
                this.getHtjeData(this.htjeSearDate);
            },
            handleCurrentChangeHtje(val) {
                this.currentNoHtje = val;
                this.getHtjeData(this.htjeSearDate);
            },
            baygSearch(){
                if (!this.baygYear) {
                    this.$message.error("请选择年份！")
                } else {
                    if (this.baygMonth) {
                        this.baygSearDate = this.baygYear + '-' + this.baygMonth
                    } else {
                        this.baygSearDate = this.baygYear
                    }
                    this.getBaygData(this.baygSearDate);
                }
            },
            lrphSearch(){
                if (this.baygMonth) {
                        this.baygSearDate = this.baygYear + '-' + this.baygMonth
                    } else {
                        this.baygSearDate = this.baygYear
                    }
                    this.getLrphData(this.baygSearDate);
            },
            getBaygData(date){
                this.loadingBayg = true;
                this.$request({
					url: '/bjba/phb/baygphb',
					method: 'get',
                    params: {
                        pageNum: this.currentNoBayg,
                        pageSize: this.pageSizeBayg,
                        date: date
                    }
				})
				.then(response => {
                    this.loadingBayg = false;
					console.log("保安用工：",response)
                    this.baygData = response.data.data
                    this.pageTotalBayg = response.data.total
				})
				.catch(error => {
					this.loadingBayg = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            getLrphData(){
                this.loadinglrph = true;
                this.$request({
					url: '/bjba/phb/lrph',
					method: 'get',
                    params: {
                        pageNum: this.currentNoBayg,
                        pageSize: this.pageSizeBayg,
                        date: this.baygMonth ? this.lrphSearDate + '-' + this.lrphMonth:this.lrphSearDate
                    }
				})
				.then(response => {
                    this.loadinglrph = false;
					console.log("保安用工m,m,",response)
                    this.baygData = response.data.data
                    this.pageTotalBayg = response.data.total
				})
				.catch(error => {
					this.loadinglrph = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            handleSizeChangeBayg(val) {
                this.pageSizeBayg = val;
                this.getBaygData(this.baygSearDate);
            },
            handleSizeChangeLrph(val) {
                this.pageSizeLrph = val;
                this.getBaygData();
            },
            handleCurrentChangeBayg(val) {
                this.currentNoBayg = val;
                this.getBaygData(this.baygSearDate);
            },
            yswskSearch(){
                if (!this.yswskYear) {
                    this.$message.error("请选择年份！")
                } else {
                    if (this.yswskMonth) {
                        this.yswskSearDate = this.yswskYear + '-' + this.yswskMonth
                    } else {
                        this.yswskSearDate = this.yswskYear
                    }
                    this.getYswskData(this.yswskSearDate);
                }
            },
            getYswskData(date){
                this.loadingYswsk = true;
                this.$request({
					url: '/bjba/phb/yswskqk',
					method: 'get',
                    params: {
                        pageNum: this.currentNoYswsk,
                        pageSize: this.pageSizeYswsk,
                        date: date
                    }
				})
				.then(response => {
                    this.loadingYswsk = false;
					console.log("应收未收款：",response)
                    this.yswskData = response.data.data
                    this.pageTotalYswsk = response.data.total
				})
				.catch(error => {
					this.loadingYswsk = false;
					console.log(error)
					this.$message.error(error)
				});
            },
            handleSizeChangeYswsk(val) {
                this.pageSizeYswsk = val;
                this.getYswskData(this.yswskSearDate);
            },
            handleCurrentChangeYswsk(val) {
                this.currentNoYswsk = val;
                this.getYswskData(this.yswskSearDate);
            }
        }
    }
</script>

<style lang="scss" scope>
.data{
    width: 90%;
    margin: 10px 0 0 5%;
    
}
.index_one {
  width: 25px;
  height: 25px;
  background-color: #fb0404;
  color: #fff;
  text-align: center;
}
.index_two {
  width: 25px;
  height: 25px;
  background-color: #ffd700;
  color: #fff;
  text-align: center;

}
.index_three {
  width: 25px;
  height: 25px;
  background-color: #3ca214;
  color: #fff;
  text-align: center;

}
.index_four {
  width: 25px;
  height: 25px;
  background-color: #1d70e1;
  color: #fff;
  text-align: center;

}
.margin_right{
    margin-right:20px;
}
.month_class .el-date-picker__header{
    display: none;
}
</style>
